import insightsClient from 'search-insights';
import { TmCart } from '@/tscapi/model/cart';

document.addEventListener(
    'order-confirmed',
    function (e: CustomEvent) {
        const orderedCart = e?.detail?.OrderedCart;
        trackSearchEventClick(orderedCart);
    },
    false,
);

const trackSearchEventClick = (orderedCart: TmCart) => {
    try {
        const trackedItems = JSON.parse(window.sessionStorage.getItem('TSC_AlgoliaCartItems')) || [];

        const objectIDs: string[] = [];
        const objectData: {
            queryID?: string;
            price: number;
            discount: number;
            quantity: number;
        }[] = [];

        orderedCart.CartLines.forEach((line) => {
            const itemNo = line.CartLineItem.ItemNo;
            objectIDs.push(itemNo);

            const trackedItem = trackedItems.find((item) => item.objectID === itemNo);

            objectData.push({
                queryID: trackedItem?.queryID,
                price: line.InCart.PriceUnit,
                discount: parseFloat(line.InCart.Discount) || 0,
                quantity: line.InCart.Quantity,
            });
        });

        insightsClient('purchasedObjectIDsAfterSearch', {
            userToken: localStorage.getItem('ALGOLIA_USER_TOKEN') || 'anonymous',
            authenticatedUserToken: localStorage.getItem('ALGOLIA_AUTH_USER_TOKEN') || undefined,
            eventName: 'Product Converted',
            index: 'products',
            objectIDs,
            objectData,
            value: orderedCart.OrderSummary.GrandTotalAmount,
            currency: 'CAD',
        });

        window.sessionStorage.removeItem('TSC_AlgoliaCartItems');
    } catch (error) {
        console.error('Error firing Algolia conversion event:', error);
    }
};
